

module.exports = __webpack_require__.stylable.create(
    "Recurrence2385460193",
    {"classes":{"root":"Recurrence2385460193__root","frequency":"Recurrence2385460193__frequency"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Recurrence2385460193",
    null
);
